import 'css-chunksrc/client/common/richTextInput/styles.scss';export default {
  "richTextInput": "_richTextInput_1iwtj_1",
  "disabled": "_disabled_1iwtj_9",
  "resizable": "_resizable_1iwtj_13",
  "toolbar": "_toolbar_1iwtj_24",
  "toolbarBtn": "_toolbarBtn_1iwtj_34",
  "active": "_active_1iwtj_54",
  "toolbarIcon": "_toolbarIcon_1iwtj_60",
  "colorInput": "_colorInput_1iwtj_67",
  "separator": "_separator_1iwtj_79",
  "editorWrapper": "_editorWrapper_1iwtj_87",
  "tableToolbar": "_tableToolbar_1iwtj_92",
  "tableToolbarBtn": "_tableToolbarBtn_1iwtj_107",
  "tableToolbarSeparator": "_tableToolbarSeparator_1iwtj_125",
  "mentionPopup": "_mentionPopup_1iwtj_133",
  "editorContent": "_editorContent_1iwtj_139",
  "selectedCell": "_selectedCell_1iwtj_260",
  "editorContentDisabled": "_editorContentDisabled_1iwtj_288",
  "charCount": "_charCount_1iwtj_294"
};